// Contacts
export const CONTACTS_FETCHED = 'CONTACTS_FETCHED';
export function contactsFetched(contacts) {
  return {
    type: CONTACTS_FETCHED,
    contacts: contacts,
  };
}
export const CONTACTS_REQUEST_STARTED = 'CONTACTS_REQUEST_STARTED';
export function contactsRequestStarted() {
  return {
    type: CONTACTS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const CONTACTS_REQUEST_ERROR = 'CONTACTS_REQUEST_ERROR';
export function contactsRequestError() {
  return {
    type: CONTACTS_REQUEST_ERROR,
  };
}
